module.exports = __webpack_public_path__ + "media/605CommonSpace.91bc91d3.webm";